<template>
  <div class="page-vasomotor-rhinitis">
    <!-- Begin head block -->
    <section class="head-block">
      <div class="container">
        <div class="head-block__bg">
          <img src="~@/assets/img/vasomotor-rhinitis/banner-bg.jpg" alt="" />
        </div>
        <div class="row">
          <div class="col-x-lg-8 col-lg-8 col-md-8 col-xs-12">
            <h1
              class="head-block__title"
              v-html="$t('vasomotorRhinitis.title')"
            ></h1>
            <div class="head-block__list">
              <h5
                class="head-block__list-title"
                v-html="$t('vasomotorRhinitis.list.title')"
              ></h5>
              <div
                class="head-block__list-item"
                v-for="(item, key) in $t('vasomotorRhinitis.list.items')"
                :key="key"
                v-html="item"
              ></div>
            </div>
            <h5
              class="head-block__subtitle"
              v-html="$t('vasomotorRhinitis.subtitle')"
            ></h5>
            <div
              class="head-block__info"
              v-html="$t('vasomotorRhinitis.info')"
            ></div>
            <div
              class="head-block__text"
              v-html="$t('vasomotorRhinitis.text')"
            ></div>
          </div>
        </div>
        <div class="icons-list">
          <div
            class="icons-list__title"
            v-html="$t('vasomotorRhinitis.iconsList.title')"
          ></div>
          <div class="icons-list__row">
            <div
              class="icons-list__col"
              v-for="(item, key) in $t('vasomotorRhinitis.iconsList.items')"
              :key="key"
            >
              <div
                :class="`icons-list__item icons-list__item--${key + 1}`"
                v-html="item.title"
              ></div>
            </div>
          </div>
          <router-link
            @click.native="rinit3MainBtn()"
            :to="$t('vasomotorRhinitis.iconsList.button.link')"
            class="icons-list__btn"
          >
            {{ $t("vasomotorRhinitis.iconsList.button.title") }}
          </router-link>
        </div>
      </div>
    </section>
    <!-- // -->
    <!-- Begin bibliography -->
    <section class="bibliography">
      <div class="container">
        <div class="bibliography__info">
          <p v-html="$t('bibliography.info_1')"></p>
        </div>
        <div class="bibliography__list">
          <h3
            class="bibliography__list-title"
            v-html="$t('bibliography.bibliographyTitle')"
          ></h3>
          <div
            class="bibliography__list-item"
            v-for="(item, key) in $t('vasomotorRhinitis.bibliography.list')"
            :key="key"
          >
            <div class="bibliography__list-number">{{ key + 1 }}.</div>
            <div class="bibliography__list-text" v-html="item"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
  </div>
</template>

<script>
export default {
  name: "VasomotorRhinitisView",
  metaInfo() {
    if (this.$i18n.locale === "ua") {
      return {
        title: "Називін та вазомоторний риніт 🤧 Симптоми і профілактика",
        meta: [
          {
            name: "description",
            content:
              "Вазомоторний риніт якщо 👃💦 при: зміна положення, вживання різної їжі ☕, зміні температури 🌡, впливу сонця ☀, без видимих причин. Профілактика: 🏋 🧑‍⚕ 🩺"
          },
          {
            property: "og:description",
            content: "Називін та вазомоторний риніт 🤧 Симптоми і профілактика"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (this.$i18n.locale === "ru") {
      return {
        title: "Називин и вазомоторный ринит 🤧 Симптомы и профилактика",
        meta: [
          {
            name: "description",
            content:
              "Вазомоторный ринит если 👃💦 при: изменение положения, применение различной пищи ☕, изменении температуры 🌡, воздействия солнца ☀, без видимых причин. Профилактика: 🏋 🧑⚕ 🩺"
          },
          {
            property: "og:description",
            content: "Називин и вазомоторный ринит 🤧 Симптомы и профилактика"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
  },
  methods: {
    insertAfter(newNode, existingNode) {
      existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    },
    responsive() {
      if (window.innerWidth <= 991) {
        var bannerImage = document.querySelector(".head-block__bg");
        var bannerTitle = document.querySelector(".head-block__title");
        this.insertAfter(bannerImage, bannerTitle);
      }
    },
    rinit3MainBtn() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "rinit_3_main_btn" });
    }
  },
  mounted() {
    this.responsive();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/views/_vasomotor-rhinitis";
</style>
